// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressGeocoderController from "./address_geocoder_controller"
application.register("address-geocoder", AddressGeocoderController)

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import CommentController from "./comment_controller"
application.register("comment", CommentController)

import DocumentFormatToggleController from "./document_format_toggle_controller"
application.register("document-format-toggle", DocumentFormatToggleController)

import FileDropzoneController from "./file_dropzone_controller"
application.register("file-dropzone", FileDropzoneController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FlashesController from "./flashes_controller"
application.register("flashes", FlashesController)

import MapboxController from "./mapbox_controller"
application.register("mapbox", MapboxController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import MatomoController from "./matomo_controller"
application.register("matomo", MatomoController)

import MatomoChartController from "./matomo_chart_controller"
application.register("matomo-chart", MatomoChartController)

import VisitorMapController from "./visitor_map_controller"
application.register("visitor-map", VisitorMapController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OperationalMapController from "./operational_map_controller"
application.register("operational-map", OperationalMapController)

import OrganizationGeocoderController from "./organization_geocoder_controller"
application.register("organization-geocoder", OrganizationGeocoderController)

import OrganizationMapController from "./organization_map_controller"
application.register("organization-map", OrganizationMapController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import RoleOrganizationController from "./role_organization_controller"
application.register("role-organization", RoleOrganizationController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SubmissionCaptchaController from "./submission_captcha_controller"
application.register("submission-captcha", SubmissionCaptchaController)

import SubscriptionToggleController from "./subscription_toggle_controller"
application.register("subscription-toggle", SubscriptionToggleController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TenderSubmissionController from "./tender_submission_controller"
application.register("tender-submission", TenderSubmissionController)

import TextLimitController from "./text_limit_controller"
application.register("text-limit", TextLimitController)

import TiptapController from "./tiptap_controller"
application.register("tiptap", TiptapController)

import ToggleStateController from "./toggle_state_controller"
application.register("toggle-state", ToggleStateController)
